import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "details-panel-placeholder__level-descriptions" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LevelsDescriptionPlaceholder = _resolveComponent("LevelsDescriptionPlaceholder")!
  const _component_ContentPlaceholders = _resolveComponent("ContentPlaceholders")!
  const _component_PxPanel = _resolveComponent("PxPanel")!

  return (_openBlock(), _createBlock(_component_PxPanel, { class: "details-panel-placeholder px-panel--mobile-no-side-borders" }, {
    header: _withCtx(() => [...(_cache[0] || (_cache[0] = [
      _createElementVNode("div", { class: "placeholder-block placeholder-block--important details-panel-placeholder__title" }, null, -1)
    ]))]),
    default: _withCtx(() => [
      _createVNode(_component_ContentPlaceholders, {
        class: "details-panel-placeholder__container",
        rounded: ""
      }, {
        default: _withCtx(() => [
          _cache[1] || (_cache[1] = _createElementVNode("div", { class: "placeholder-block details-panel-placeholder__grid" }, null, -1)),
          _cache[2] || (_cache[2] = _createElementVNode("hr", null, null, -1)),
          _createElementVNode("div", _hoisted_1, [
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(8, (i) => {
              return _createVNode(_component_LevelsDescriptionPlaceholder, {
                key: i,
                class: "details-panel-placeholder__level-descriptions-entry"
              })
            }), 64))
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}